import { useAuth } from '../contexts/AuthContext';
import { AcessibilidadeWidget } from './AcessibilidadeWidget';

/**
 * Botão flutuante de acessibilidade só nas telas sem header (deslogado/público).
 * Logado, o botão aparece inline no header, ao lado do sino.
 */
export function AcessibilidadeFlutuante() {
  const { session } = useAuth();
  if (session) return null;
  return <AcessibilidadeWidget variant="fixo" />;
}
